/**
 * Fork overlay (new file, no OSS equivalent) — EVA-M7 (7.1).
 * Pull the backend's validation messages out of an Eva API error. Eva controllers render 422s as
 * { errors: [...] } (base_controller rescue_from), so this returns that array (empty when absent) —
 * callers join it or fall back to generic copy as they prefer.
 */
export const evaErrorMessages = error => error?.response?.data?.errors ?? [];
